/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module ApplicationcontrolTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface ApplicationControl {
    [k: string]: any;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "ReadConfigParameters".
 */
export interface ReadConfigParameters {
    appname: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "WriteConfigParameters".
 */
export interface WriteConfigParameters {
    appname: string;
    data: string[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "ReadGenericConfigParameters".
 */
export interface ReadGenericConfigParameters {
    configname: string;
    /**
     * List of json nodes in order of hierarchy starting from root
     */
    path: string[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "ReadReturn".
 */
export interface ReadReturn {
    path: {
        key: string;
        value: string;
    }[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "WriteGenericConfigParameters".
 */
export interface WriteGenericConfigParameters {
    configname: string;
    /**
     * nodes to read
     */
    path: {
        key: string;
        value: string;
    }[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "RemoveParameters".
 */
export interface RemoveParameters {
    configname: string;
    path: string[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "LastInstallerStatusReturn".
 */
export interface LastInstallerStatusReturn {
    errorcode: string;
    clientversion: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "DeleteCookiesParameters".
 */
export interface DeleteCookiesParameters {
    url: string;
    cookiename?: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "SetTaskbarProgressParameters".
 */
export interface SetTaskbarProgressParameters {
    state: State;
    percent?: number;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "LoadStringTableParameters".
 */
export interface LoadStringTableParameters {
    stringTable: {
        [k: string]: any;
    };
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "AllowSetForegroundWindowParameters".
 */
export interface AllowSetForegroundWindowParameters {
    pid: number;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "CopyToClipboardParameters".
 */
export interface CopyToClipboardParameters {
    /**
     * data to copy to clipboard
     */
    clipBoardData: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "RestartParameters".
 */
export interface RestartParameters {
    launchArguments: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "ModulesActiveNotificationReturn".
 */
export interface ModulesActiveNotificationReturn {
    /**
     * List of detected modules
     */
    modules: {
        module: string;
        state: State1;
    }[];
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "OpenLinkInExternalBrowserParameters".
 */
export interface OpenLinkInExternalBrowserParameters {
    url: string;
}
/**
 * This interface was referenced by `ApplicationControl`'s JSON-Schema
 * via the `definition` "SetCEFWindowThemeParameters".
 */
export interface SetCEFWindowThemeParameters {
    systemTheme: SystemTheme;
}

export enum State {
    percentage = 'percentage',
    indeterminate = 'indeterminate',
    pause = 'pause',
    complete = 'complete'
}
export enum State1 {
    active = 'active',
    inactive = 'inactive',
    failed = 'failed'
}
export enum SystemTheme {
    light = 'light',
    dark = 'dark'
}


}
